import React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";

interface PrivateRouteProps extends RouteProps {
  component: React.ComponentType<any>;
  routeWrapper?: React.ComponentType<any>;
}

/**
 * PrivateRoute component that protects routes requiring authentication
 * Redirects to /platform if user is not logged in
 */
const PrivateRoute: React.FC<PrivateRouteProps> = ({
  component: Component,
  routeWrapper: RouteWrapper,
  ...rest
}) => {
  const isAuthenticated = !!localStorage.getItem("RwaAuthToken");

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isAuthenticated) {
          return <Redirect to="/platform" />;
        }

        // If RouteWrapper is provided, use it (for pages that need Layout)
        if (RouteWrapper) {
          return <RouteWrapper component={Component} {...props} />;
        }

        // Otherwise, render component directly
        return <Component {...props} />;
      }}
    />
  );
};

export default PrivateRoute;
